import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useStore } from "../context/StoreContext";

export default function PaymentCancel() {
  const { L } = useStore();
  return (
    <div className="pt-40 pb-32 min-h-screen flex flex-col items-center justify-center text-center px-5" data-testid="payment-cancel-page">
      <XCircle className="w-16 h-16 text-gold" strokeWidth={1.2} />
      <h1 className="font-display text-4xl text-ivory mt-6">{L.pay.cancelTitle}</h1>
      <p className="text-sand text-sm max-w-md mt-4 leading-relaxed">{L.pay.cancelMsg}</p>
      <div className="flex flex-wrap justify-center gap-4 mt-10">
        <Link to="/shop" data-testid="payment-cancel-back" className="btn-gold rounded-full px-8 py-3.5 text-[0.7rem] tracking-[0.25em] uppercase font-semibold">
          {L.pay.backToShop}
        </Link>
        <Link to="/" data-testid="payment-cancel-home" className="btn-ghost rounded-full px-8 py-3.5 text-[0.7rem] tracking-[0.25em] uppercase">
          ARIJ MISK
        </Link>
      </div>
    </div>
  );
}
